export default "__VITE_PUBLIC_ASSET__a676f38c__"